import { Controller } from "@hotwired/stimulus"
import { patch } from "@rails/request.js"

// Connects to data-controller="change-cheatsheet-status"
export default class extends Controller {
  static targets = ["select"]

  connect() {
    this.updateStatus.bind(this)
    this.updateStatus()
  }

  async changeStatus() {
    this.selectTarget.disabled = true

    const response = await patch(this.element.action, {
      body: {
        cheatsheet: {
          status: this.selectTarget.value
        }
      }
    })

    if (response.ok) {
      this.selectTarget.style.backgroundColor = "lightgreen"

      this.updateStatus()

      setTimeout(() => {
        this.selectTarget.style.backgroundColor = "white"
      }, 250)
    }

    this.selectTarget.disabled = false

    // to reload the page an update "view public page" button
    window.location.reload()
  }

  updateStatus() {
    if (this.selectTarget.value === "published") {
      document.getElementById("unpublished-cheatsheet-status").classList.add("hidden")
    } else {
      document.getElementById("unpublished-cheatsheet-status").classList.remove("hidden")
    }
  }
}
